import { useQuery } from '@apollo/react-hooks';
import { FormInput, FormInputProps } from 'modules';
import { BankListQuery } from 'queries/Bank/Bank';
import React from 'react';

interface BankSelectProps extends FormInputProps {
  outputValue?: (data: GQL.IBank) => any;
}

const BankSelect = (props: BankSelectProps) => {
  const { data, loading } = useQuery(BankListQuery);

  const getOptions = () => {
    if (data && data.bankList) {
      return data.bankList
        .filter((s: GQL.IBank) => s.kod?.substr(0, 1) !== '_')
        .map((s: GQL.IBank) => {
          return {
            label: `${s.banka} (${s.kod})`,
            value: s.id,
          };
        });
    }

    return [];
  };

  const onChange = (e: React.ChangeEvent) => {
    if (props.onChange) {
      const { name, value } = e.target as HTMLInputElement;
      const bank = data?.bankList?.find((b: GQL.IBank) => b.id === value);
      if (props.outputValue) {
        props.onChange({
          target: {
            name,
            value: props.outputValue(bank),
          },
        });
      } else {
        props.onChange(e);
      }
    }
  };

  return (
    <FormInput
      {...props}
      type="select"
      placeholder={loading ? 'Načítám ...' : 'Vyberte ...'}
      disabled={loading}
      options={getOptions()}
      onChange={onChange}
    />
  );
};

export default BankSelect;
